exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3VEJm5PBPym2EOrfPoXRNr .ms-Dialog-action,html[dir] ._3VEJm5PBPym2EOrfPoXRNr .ms-Dialog-actionsRight{margin:initial}._3VEJm5PBPym2EOrfPoXRNr ._3-HVsHc37hkKhpS4dVI1jk{width:100%}html[dir] ._3VEJm5PBPym2EOrfPoXRNr ._3-HVsHc37hkKhpS4dVI1jk{margin:10px 0}", ""]);

// exports
exports.locals = {
	"dialog": "_3VEJm5PBPym2EOrfPoXRNr",
	"footerButton": "_3-HVsHc37hkKhpS4dVI1jk"
};